module.exports = __webpack_public_path__ + "static/media/icon-charging.91aa0fcc.91aa0fcc.png";